export default __webpack_public_path__ + "static/media/logo-certificado.22d51640.png";